/**
 * 区分 transactionStatus（transaction_statuses.transaction_status）
 * 274（10/13 ユーザー判断）：旧PCRM の 7 段階に戻した。値は旧（frontend/src/utils/statusConfig.ts の TRANSACTION_STATUS_CONFIG）と同じ
 * approach・scheduling・meeting・preparing・proposing・won・lost。説明文は旧の取引登録（TransactionForm の STATUS_OPTIONS）の文言。
 * 新だけの値（pending＝商談中）は消した。既存のデータは apps/api/migration/274-a4-transaction-status.ts で approach に付け替える。
 * lost は失注として集計から除く固定の値（要件書 5.4 の式）
 */
export const TRANSACTION_STATUS_VALUES = [
  'approach',
  'scheduling',
  'meeting',
  'preparing',
  'proposing',
  'won',
  'lost',
] as const;

export type TransactionStatus = (typeof TRANSACTION_STATUS_VALUES)[number];

export const TRANSACTION_STATUS_LABELS: Readonly<Record<TransactionStatus, string>> = {
  approach: 'アプローチ',
  scheduling: '打ち合わせ調整',
  meeting: '打ち合わせ実施',
  preparing: '提案準備',
  proposing: '提案中',
  won: '成約',
  lost: '失注',
};

/** 取引ステータスの説明文（旧 SCR-037・038 のステータスの選択肢の下の文） */
export const TRANSACTION_STATUS_DESCRIPTIONS: Readonly<Record<TransactionStatus, string>> = {
  approach: 'メールの送信や電話などでアプローチした状態',
  scheduling: '打ち合わせ日・方法の調整中',
  meeting: 'ヒアリングやフォローを行った状態',
  preparing: '提案書や見積を作成中',
  proposing: '提案を顧客に提示済',
  won: '契約が成立した状態',
  lost: '取引不成立',
};

/**
 * 新だけにあった値 → 旧の値（274：既存データの付け替え・移行の対応表で使う）。
 * 商談中→アプローチ、受注→成約（won のまま）、失注→失注（lost のまま）
 */
export const LEGACY_TRANSACTION_STATUS_REMAP: Readonly<Record<string, TransactionStatus>> = {
  pending: 'approach',
};

/** 旧PCRM の取引の status（pending を含む）→ 新の値。旧に pending が残っていた行はアプローチに寄せる */
export function transactionStatusFromLegacy(value: string | null | undefined): TransactionStatus {
  if (value && (TRANSACTION_STATUS_VALUES as readonly string[]).includes(value)) {
    return value as TransactionStatus;
  }
  return (value && LEGACY_TRANSACTION_STATUS_REMAP[value]) || 'approach';
}
